import * as React from 'react';
import { colors } from '../../../index';

const IconWarning = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 14 14",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.007 9.677a.593.593 0 00-.59.583c0 .318.269.584.59.584.309 0 .59-.266.576-.57a.573.573 0 00-.576-.597z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.66 11.919a2.47 2.47 0 00.005-2.493L9.158 1.599A2.447 2.447 0 007.003.344c-.904 0-1.71.47-2.156 1.252L.335 9.431a2.49 2.49 0 00.008 2.508 2.462 2.462 0 002.15 1.238h9.002c.9 0 1.71-.47 2.164-1.258zm-.98-.566a1.36 1.36 0 01-1.188.69H2.49c-.49 0-.93-.251-1.174-.675a1.369 1.369 0 01-.003-1.377L5.826 2.16c.244-.43.682-.684 1.177-.684.492 0 .932.257 1.177.687l4.51 7.832c.241.421.238.93-.01 1.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.863 4.448c-.275.1-.446.416-.446.8.014.232.025.467.039.699l.118 2.63c.014.3.196.517.432.517.235 0 .42-.232.432-.534 0-.182 0-.35.014-.534l.078-1.698c.014-.367.04-.733.053-1.1 0-.132-.014-.25-.053-.367-.118-.328-.393-.495-.667-.413z"
  })));
};

export default IconWarning;